import React, { useState, useEffect } from "react";
import "./login.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { database } from "../../database/firebase";
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  collection,
} from "firebase/firestore";
import axios from "axios";
import Swal from "sweetalert2";
import { sendReport } from "../polls/sendReports";

function Login({ updateHeader }) {
  const location = useLocation();

  // Use URLSearchParams to access the query parameters
  const queryParams = new URLSearchParams(location.search);
  const getOtp = queryParams.get("otp");
  const role = queryParams.get("role");
  const [otp, setOtp] = useState(getOtp);
  const [isLoggedIn, setIsLoggedIn] = useState(false); // To control login state
  const [themeData, setThemeData] = useState(null);
  const [pollingLogo, SetPollingLogo] = useState("/img/polling-logo.png");
  const [isLogoSet,SetIsLogoSet]=useState(false);
  const [showEnter, setShowEnter] = useState(false);
  const navigate = useNavigate();

  const uuid4 = () => {
    // Generates something like 'e3b0c442-98fc-4b1d-a7f3-0d8d9a0a1b1e'
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };

  const handleSuccess = (msg) => {
    Swal.fire({
      icon: "success",
      title: "Success!",
      text: msg,
      customClass: {
        popup: "custom-success-popup", // Apply your custom class
      },
    });
  };

  const handleError = (msg) => {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: msg,
      customClass: {
        popup: "custom-success-popup", // Apply your custom class
      },
    });
  };

  const handleLogin = () => {
    if (queryParams.get("save")) {
      console.log("ignoring latest update...");
    } else {
      let apiUrl;
      const requestData = { otp: otp };
      let source = null;

      if (role === "GUEST_USER") {
        apiUrl = process.env.REACT_APP_FIREBASE_GUEST_USER_API;
        requestData.role = "GUEST_USER";
        source = "GUEST_USER";
      } else {
        apiUrl = process.env.REACT_APP_FIREBASE_LOGIN_API;
        source = "ORG_USER";
      }

      const headers = {
        "client-secret": process.env.REACT_APP_FIREBASE_CLIENT_SECRET,
        "Content-Type": "application/json",
        "Idempotency-Key": uuid4(),
      };

      axios
        .post(apiUrl, requestData, { headers })
        .then(async (response) => {
          console.log("API TRIGGER");
          if (response.data.message === "LOGIN SUCCESS") {
            console.log(response.data.data.gameId);
            let finalCompanyLogo = null;
            const responseOrg = await axios.get(
              process.env.REACT_APP_ORG_API +
                "/" +
                response.data.data.organizationId,
              { organizationId: response.data.data.organizationId },
              { headers }
            );
            if (
              responseOrg.data.message ===
              "ORGANIZATIONS_FETCHED_SUCCESSFULLY"
            ) {
              let companyLogo = responseOrg.data.organization.companyLogo;
              finalCompanyLogo = process.env.REACT_APP_S3_SOURCE + companyLogo;
              if(responseOrg.data?.organization.companyLogo=="" || responseOrg.data?.organization.companyLogo==null){
                finalCompanyLogo=process.env.REACT_APP_EM_LOGO;
              }
              updateHeader({
                imageUrl: finalCompanyLogo,
                backButtonRedirect:
                  process.env.REACT_APP_BASE_URL +
                  "/game-detail/" +
                  response.data.data.gameId, // New Back Button Target
              });
            }
            console.log(responseOrg);

            const userId =
              role === "GUEST_USER"
                ? response.data.data.id
                : response.data.data.userId;

            let name = `${response.data.data.firstName} ${response.data.data.lastName}`;
            let email = response.data.data.email;
            let playedCount= response.data.data.userPlayedCount;
            console.log("even checking ??", role);
            if (role === "GUEST_USER") {
              const teamname = response.data.data.userCustomFieldsData?.teamname;
              if (teamname) {
                name = teamname;
              } else if (
                response.data.data.firstName === null ||
                response.data.data.firstName === ""
              ) {
                if (response.data.data.email) {
                  // Extract the part before '@' in the email (email has priority)
                  name = response.data.data.email.split("@")[0];
                } else if (response.data.data.employeeId) {
                  // Use employeeId as name if email is not present (although email will be present as per your note)
                  name = response.data.data.employeeId;
                  email = response.data.data.employeeId;
                } else {
                  name = "Guest"; // Fallback name if both email and employeeId are unavailable
                }
              }
            }

            const userData = {
              userId: userId,
              sessionId: response.data.data.sessionId,
              organizationId: response.data.data.organizationId,
              gameId: response.data.data.gameId,
              name: name,
              email: email,
              token: response.data.data.token,
              expiry: new Date().getTime() + 24 * 60 * 60 * 1000,
              source: source,
            };
            console.log(userData);
            sessionStorage.setItem("userData", JSON.stringify(userData));

            // Reference to the user's document inside the session's users collection
            const userDocRef = doc(
              database,
              `sessions/${userData.sessionId}/users/${userData.userId}`
            );

            const reportData = {
              sessionId: userData.sessionId,
              role: userData.source,
              token: userData.token || null,
              name: userData.name,
              userId: userData.userId,
              gameId: userData.gameId || "",
              organizationId: userData.organizationId,
              points: 0,
              time: "00:00:00",
              reportId: userData.reportId || null,
              ans: "",
            };



            // Check if the user already exists
            getDoc(userDocRef)
              .then((userSnapshot) => {
                if (userSnapshot.exists()) {
                  console.log(
                    "trying to initiate---",
                    userData.sessionId + userData.userId
                  );
                  console.log(
                    sessionStorage.getItem(userData.sessionId + userData.userId)
                  );
                  if(playedCount==0){
                    sendReport(reportData)
                      .then((apiRes) => {
                        console.log(apiRes);
                        userData.reportId = apiRes?.data?.id ?? apiRes?.data?.reportId;
                        sessionStorage.setItem(
                          "userData",
                          JSON.stringify(userData)
                        );
                        // sessionStorage.setItem(
                        //   userData.sessionId + userData.userId,
                        //   "true"
                        // );
                        console.log("✔ Report API SUCCESS:", apiRes);
                      })
                      .catch((err) => {
                        console.error("❌ Report API FAILED:", err);
                      })
                      .finally(() => {
                        console.log("⚠ finally() executed — success OR fail");
                      });
                  }
             

                  setIsLoggedIn(true);
                  console.log(
                    "Current user already exists! Ignoring update..."
                  );
                  if (queryParams.get("admin")) {
                    window.location.href =
                      process.env.REACT_APP_ADMIN_REDIRECT +
                      "?sessionId=" +
                      response.data.data.sessionId +
                      "&userId=" +
                      userId +
                      "&organizationId=" +
                      response.data.data.organizationId +
                      "&gameId=" +
                      response.data.data.gameId +
                      "&company_logo=" +
                      finalCompanyLogo;
                  }
                } else {
                  // If the user doesn't exist, add a new document
                  if(playedCount==0){
                    sendReport(reportData)
                      .then((apiRes) => {
                        console.log(apiRes);
                        userData.reportId = apiRes?.data?.id ?? apiRes?.data?.reportId;
                        sessionStorage.setItem(
                          "userData",
                          JSON.stringify(userData)
                        );
                        // sessionStorage.setItem(
                        //   userData.sessionId + userData.userId,
                        //   "true"
                        // );
                        console.log("✔ Report API SUCCESS:", apiRes);
                      })
                      .catch((err) => {
                        console.error("❌ Report API FAILED:", err);
                      })
                      .finally(() => {
                        console.log("⚠ finally() executed — success OR fail");
                      });
                  }
                  // console.log(
                  //   "trying to initiate---",
                  //   userData.sessionId + userData.userId
                  // );
                  // console.log(
                  //   sessionStorage.getItem(userData.sessionId + userData.userId)
                  // );
                  // if (
                  //   !sessionStorage.getItem(
                  //     userData.sessionId + userData.userId
                  //   )
                  // ) {
                  //   sendReport(reportData)
                  //     .then((apiRes) => {
                  //       userData.reportId = apiRes.data.id;
                  //       sessionStorage.setItem(
                  //         "userData",
                  //         JSON.stringify(userData)
                  //       );
                  //       sessionStorage.setItem(
                  //         userData.sessionId + userData.userId,
                  //         "true"
                  //       );
                  //       console.log("✔ Report API SUCCESS:", apiRes);
                  //     })
                  //     .catch((err) => {
                  //       console.error("❌ Report API FAILED:", err);
                  //     })
                  //     .finally(() => {
                  //       console.log("⚠ finally() executed — success OR fail");
                  //     });
                  // }

                  setIsLoggedIn(true);
                  setDoc(userDocRef, {
                    userId: userData.userId,
                    organizationId: userData.organizationId,
                    sessionId: userData.sessionId,
                    name: userData.name,
                    email: userData.email,
                    timestamp: Date.now(),
                    source: source,
                  });
                  if (queryParams.get("admin")) {
                    window.location.href =
                      process.env.REACT_APP_ADMIN_REDIRECT +
                      "?sessionId=" +
                      response.data.data.sessionId +
                      "&userId=" +
                      userId +
                      "&organizationId=" +
                      response.data.data.organizationId +
                      "&gameId=" +
                      response.data.data.gameId +
                      "&company_logo=" +
                      finalCompanyLogo;
                  }
                }

                if (queryParams.get("admin") === "true") {
                  console.log("Access denied.");
                } else {
                  fetch(
                    process.env.REACT_APP_FETCH_THEMEDATA +
                      "?sessionId=" +
                      response.data.data.sessionId +
                      "&userId=" +
                      userId +
                      "&organizationId=" +
                      response.data.data.organizationId
                  ) // Replace with your API URL
                    .then((response) => {
                      if (!response.ok) {
                        throw new Error(
                          `HTTP error! status: ${response.status}`
                        );
                      }
                      return response.json();
                    })
                    .then((json) => {
                      sessionStorage.setItem("themeData", JSON.stringify(json));
                      setThemeData(json);
                      console.log(json);
                    })
                    .catch((err) => {
                      console.log(err.message); // Handle error
                    });
                }
              })
              .catch((error) => {
                handleError("Login failed! Please try again.");
                console.error("Error processing user data:", error);
              });
          } else {
            handleError("Login failed! Please try again.");
          }
        })
        .catch((error) => {
          console.error(
            "Login Failed:",
            error.response?.data?.err?.message || "An error occurred"
          );
          handleError("Login failed! Please try again.");
        });
    }
  };

  useEffect(() => {
    // // First-time login
    // const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
    // if (storedUserData) {
    //   sessionStorage.removeItem('userData');
    // }
    handleLogin();
  }, []); // Runs once on component mount

  useEffect(() => {
    if (themeData != null) {
      const body = document.body;
      if (body.classList.contains("common-bg")) {
        console.log(themeData.background_desk);
        body.style.backgroundImage = `url(${themeData.background_desk})`;
      }
      SetPollingLogo(themeData.logo);
      SetIsLogoSet(true);
      setShowEnter(true);
    }
  }, [themeData]);

  useEffect(() => {
    setTimeout(function () {
      if (queryParams.get("save")) {
        let getThemeData = sessionStorage.getItem("themeData");
        getThemeData = JSON.parse(getThemeData);
        console.log(getThemeData);
        let body = document.body;
        setIsLoggedIn(true);
        if (getThemeData) {
          if (body.classList.contains("common-bg")) {
            console.log(getThemeData.background_desk);
            console.log(getThemeData.logo);
            body.style.backgroundImage = `url(${getThemeData.background_desk})`;
            SetPollingLogo(getThemeData.logo);
            SetIsLogoSet(true);
          } else {
            console.log("not able to find common bg");
          }
          setShowEnter(true);
          console.log("sessioin state updated!");
        }
      }
    }, 1000);
  }, []);

  return (
    <>
      {
      (isLogoSet) ?   
      <div className="login-main-container" style={{ textAlign: "center"}}>
      <img src={pollingLogo} className="login-logo" />
      </div>
      :
      <>
        <div class="loader">
        <div class="bar"></div>
        <div class="bar"></div>
        <div class="bar"></div>
        </div>
      </>
    
      }
      {showEnter ? (
        <div style={{ textAlign: "center" }}>
          <Link to="/polls">
            <img src="/img/begin-play.png" className="begin-play-img" />
          </Link>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default Login;
